export default function getImageFilename(itemName) {
    const cleanName = itemName
        .replace('/', '')
        .replace('Rockwell_Recipes:_', '')
        .replace('Genesis:', 'Genesis')
        .replace(/\s/g, '_');

    return `${cleanName}.png`;
}
